const methods = {
  formatLikeCount(x) {
    // TODO : 추후 1k 넘을 때 처리
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  },
}

export default methods
